import apiFetch from '@wordpress/api-fetch';

const getFormData = async (formId) => {

    return await apiFetch({ path: 'rc-forms/v1/get/' + formId }).then((formData) => {
        return formData;
    });
}

const submitForm = async (form) => {

    let formId = form.formId;
    let formData = JSON.stringify(form.formData);

    return await apiFetch({
        path: 'rc-forms/v1/submit/' + formId,
        method: 'POST',
        data: {
            'form_data': formData,
        }
    }).then((validateStatus) => {
        return validateStatus;
    });
}

const sendEamil = async (formId, submissionId) => {

    return await apiFetch({ path: 'rc-forms/v1/email/' + formId + '/' + submissionId }).then((emailStatus) => {
        return emailStatus;
    });
}

export { getFormData, submitForm, sendEamil };